import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

const initialState = {
  response: null,
  isFetching: false,
  isSuccess: false,
  isUpdated: false,
  isError: false,
  errorMessage: '',
  singleRole: [],
};

export const getRole = createAsyncThunk(
  'userRoles/detailed/?roleName=',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;

      let response = await axios({
        url: `/api/userRoles/detailed/?roleName=${udata}`,
        method: 'get',
        //timeout: 8000,
        headers: {
          //'Content-Type': 'application/json',
          "Authorization": `Bearer ${tokenStr}`
        }
      })

      // const response = await axios.get('/api/userRoles/',udata, { headers: {"Authorization" : `Bearer ${tokenStr}`} });

      let data = response.data;
      if (response.status === 200) {

        return data;
      }
      else if (response.status === 201) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);


export const editRole = createAsyncThunk(
  'roles/editrole',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      const response = await axios.patch('/api/userRoles', udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

      let data = response.data;
      // console.log(data)
      if (response.status === 200) {
        return data;
      }
      else if (response.status === 201) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);

export const editRoleSlice = createSlice({
  name: 'editrole',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clearStateAddRole: (state, { payload }) => {
      state.response = null;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
      state.isSuccess = false;
      state.isUpdated = false;
    },
    isSuccess: (state, { payload }) => {
      state.response = null;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
      state.isSuccess = false;
      state.isUpdated = false;
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: {
    [getRole.fulfilled]: (state, { payload }) => {
      //console.log(payload.data);
      state.singleRole = payload.data;
      state.response = payload;
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [getRole.pending]: (state) => {
      state.isFetching = true;
    },
    [getRole.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    },


    [editRole.fulfilled]: (state, { payload }) => {
      // console.log(payload.data)
      if (payload.success == false) state.isError = true;
      else state.isError = false;
      if (payload.success) state.isUpdated = true;
      if (payload.message) state.errorMessage = payload.message;
      else state.errorMessage = '';

      return state;
    },
    [editRole.pending]: (state) => {
      state.isFetching = true;
    },
    [editRole.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    }

  },
});

export const { clearStateAddRole, isSuccess } = editRoleSlice.actions;

export function clearState() {

  return async (dispatch) => {
    dispatch(clearStateAddRole());
  }
}

export function clearStateSuccess() {

  return async (dispatch) => {
    dispatch(isSuccess());
  }
}

export const editRoleSelector = (state) => state.editrole;

export default editRoleSlice.reducer;
